import * as DateFormats from '@/datas/DateFormats'
import { checkDate, roundUp } from '@/helpers/functions'
import { errHandler } from '@/helpers/errorHandler'
import { getDateOfCertainFormat, unixTimeStampToDate } from '@/helpers/date'
import { getParamsUrl } from '@/helpers/request'
import { isMobile } from 'mobile-device-detect'
import { mapGetters } from 'vuex'
import { sliceDate, wordDate } from '@/helpers/filterDate'

export default {
  computed: {
    widthDialog() {
      return isMobile ? '100%' : '60%'
    },
    ...mapGetters({
      getDocumentTypeIdByType: 'documentTypes/getDocumentTypeIdByType',
      getDocumentTypes: 'documentTypes/getDocumentTypes',
      getDocumentByType: 'documentTypes/getDocumentByType',
      userInfo: 'userProfile/userInfo',
    }),
    isMobile() {
      return this.isDriverRole ? true : isMobile
    },
    isCeoRole() {
      return this.userInfo.user_type === 6
    },
    isAdminOrCeoRole() {
      return [1, 6].includes(this.userInfo.user_type)
    },
    isDriverRole() {
      return this.userInfo.user_type === 4
    },
    isDispatcherRole() {
      return this.userInfo.user_type === 3
    },
    cur_org_inn() {
      return this.userInfo?.current?.organization.inn || ''
    },
    curOrgShortName() {
      return this.userInfo?.current?.organization.short_name || ''
    },
    curUserOrgId() {
      return this.userInfo && this.userInfo.current
        ? this.userInfo.current.id
        : 0
    },
    curOrgId() {
      return this.userInfo && this.userInfo.current
        ? this.userInfo.current.organization.id
        : 0
    },
  },
  methods: {
    canAction(action) {
      return this.$canAction(action, this.userInfo)
    },
    checkApproveStatus(res) {
      const {
        master_approve_id,
        'master-approve': approve,
        masterApprove,
      } = res
      const master = approve || masterApprove

      return master_approve_id !== null && master ? Number(master.status) : 0
    },
    getRound(num, discharge = 2) {
      return num ? Number(num.toFixed(discharge)).toLocaleString('ru-RU') : 0
    },
    errHandler(err) {
      this.$message.closeAll()

      if (!err) {
        err = {}
      }
      this.$message({
        showClose: true,
        message: errHandler(err),
        type: 'error',
        duration: 5000,
      })
    },
    getCurrentUserOrganization() {
      if (!this.userInfo.current || !this.userInfo.current.organization) {
        return {}
      }

      return this.userInfo.profile.user_organizations.filter(
        org => org.organization.inn === this.userInfo.current.organization.inn,
      )
    },
    checkProfile() {
      return !(!this.userInfo.profile.fio || !this.userInfo.profile.passport)
    },
    checkCurrentUserOrganization(currUserOrg) {
      if (currUserOrg.length > 0) {
        if (!currUserOrg[0].bik) {
          return false
        }
        if (!currUserOrg[0].checking_account) {
          return false
        }
        if (!currUserOrg[0].core_account) {
          return false
        }
        if (!currUserOrg[0].name_bank) {
          return false
        }
      } else {
        return false
      }

      return true
    },
    statHaveObject() {
      let currUserOrg
      let stats = {
        curOrgCompleate: true,
        profileCompleate: true,
        allCompleate: true,
      }

      if (this.isDriverRole) {
        currUserOrg = this.getCurrentUserOrganization()
        stats.curOrgCompleate = this.checkCurrentUserOrganization(currUserOrg)
        stats.profileCompleate = this.checkProfile()
        stats.allCompleate = stats.curOrgCompleate && stats.profileCompleate
      }

      return stats
    },
    filLibs() {
      this.$store.dispatch('libs/setLibs')
      this.$store.dispatch('documentTypes/init')
    },
    downloadRegistryBlanc(paramsRegistry) {
      const token = localStorage.getItem('auth-token')
      const isProd = process.env.NODE_ENV === 'production'
      const baseURL = isProd
        ? process.env.VUE_APP_API_URL_PROD
        : process.env.VUE_APP_API_URL
      const params = getParamsUrl({
        ...paramsRegistry,
        'bearer-token': token,
      })
      const url = `${baseURL}excel-builder/registry${params}`
      const link = document.createElement('a')

      link.href = url
      link.setAttribute('download', '')
      link.setAttribute('target', '_blank')
      document.body.appendChild(link)
      link.click()
      link.remove()
    },
    forceFileDownload(response, filename = false) {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')

      link.href = url
      link.setAttribute('download', filename ? filename : 'file.zip') // or any other extension
      document.body.appendChild(link)
      link.click()
      window.URL.revokeObjectURL(url)
      // link.remove()
    },
    downloadRegistry({ res = null, headerContent = '', path = '', blank = 0 }) {
      const url = path
        ? path
        : window.URL.createObjectURL(new Blob([res?.data]))
      const link = document.createElement('a')

      link.href = url
      link.setAttribute('download', path ? '' : `${headerContent}.xlsx`)

      if (blank) {
        link.setAttribute('target', '_blank')
      }
      document.body.appendChild(link)
      link.click()

      if (!path) {
        window.URL.revokeObjectURL(url)
      }
      link.remove()
    },
    shortFio(fio) {
      if (fio) {
        const arr = fio.split(' ')
        const resultArr = arr.filter(item => item.length > 0)
        let short = `${resultArr[0]} `

        for (let i = 1; i < resultArr.length; i++) {
          short += `${resultArr[i][0]}.`
        }

        return short
      }

      return ''
    },
    shortIP(ip) {
      if (ip) {
        const arr = ip.split(' ')
        const resultArr = arr.filter(item => item.length > 0)

        let short = `${resultArr[0]} ${resultArr[1]} `

        for (let i = 2; i < resultArr.length; i++) {
          short += `${resultArr[i][0]}.`
        }

        return short
      }

      return ''
    },
    getDateOfCertainFormat(date, format = 'fullDateWithTime') {
      return this.dateToFormat(unixTimeStampToDate(date), format)
    },
    dateToFormat(date, format = 'fullDateWithTime', flag = false) {
      if (!date) {
        return ''
      }

      return getDateOfCertainFormat(date, DateFormats[format], flag)
    },
    clearSpace(eventData) {
      return eventData ? eventData.replace(/\s/g, '') : ''
    },
  },
  filters: {
    getHumanDate(date) {
      return checkDate(date)
    },
    sliceDate(value) {
      return sliceDate(value)
    },
    wordDate(value, flag = '') {
      let filtered = wordDate(value)

      if (flag) {
        filtered = flag + filtered
      }

      return filtered
    },
    getPrice(price) {
      return price ? `${roundUp(price, 1000)} руб/кг` : 'не указана'
    },
  },
}
